<template>
   <div class="slick-wrapper">
    <slot></slot>
  </div>
</template>
<script>

/**
 * ==================================
 *  Slick Slideshow Vue.js Component
 * ==================================
 *
 * <slick
 *        :autoplay="true|false"
 *        :pause-on-hover="true|false"
 * >...</slick>
 */

import { mapGetters } from 'vuex';
import Slick from 'slick-carousel';

export default {
    props: {
        // Be sure to specify with a :vue prop like:
        // <slick :autoplay="true">
        // pass :options="{ setAppendArrows: true, setAppendDots: true }" to set custom el for dots and/or arrows. use setAppendPaging: true to add paging to the gallery
        autoplay: {
            default: false,
            type: Boolean
        },
        pauseOnHover: {
            default: false,
            type: Boolean
        },
        speed: {
            default: 1500,
            type: Number
        },
        slideTotal: {
            default: 0,
            type: Number
        },
        dots: {
            type: Boolean,
            default: true
        },
        options: {
            type: Object,
            default: () => {
                return {};
            }
        },
        modalOpen: {},
        phone: {
            type: Boolean,
            default: false
        },
        shouldFadeIn: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        slick: false,
        el: false,
        viewport: 0,
        reset: false,
        currentSlide: 0,
        svgArrowPrev: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20"><path d="M10 2.35L8.0972 0 0 10l8.0972 10L10 17.65 3.8192 10z"/></svg>`,
        svgArrowNext: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20"><path d="M10 2.35L8.0972 0 0 10l8.0972 10L10 17.65 3.8192 10z"/></g></svg>`
    }),
    mounted() {
        let htmlPaging = `<div class="gallery-paging">1 of ${this.numSlides}</div>`;
        let prevArrow = `<button type="button" class="slick-arrow slick-prev" aria-label="View previous slide">${this.svgArrowPrev}</button>`;
        let nextArrow = `<button type="button" class="slick-arrow slick-next" aria-label="View next slide">${this.svgArrowNext}</button>`;
        $(this.$el).slick({
            speed: 500,
            dots: this.dots,
            autoplay: this.autoplay,
            autoplaySpeed: this.speed,
            pauseOnHover: this.pauseOnHover,
            prevArrow: this.options.setAppendPaging ? prevArrow + htmlPaging : prevArrow,
            nextArrow: nextArrow,
            appendArrows: this.options.setAppendArrows ? $(".slider-navigation") : $(this.$el),
            appendDots: this.options.setAppendDots ? $(".slider-dots") : $(this.$el),
            initialSlide: this.modalImageIndex,
            mobileFirst: true,
            lazyLoad: 'ondemand',
            ...this.options,
        });

        this.slick = $(this.$el).slick;

        // pause slideshow on click, and make it sticky
        $(this.$el).on('click', function() {
            this.slick.slickPause();
        });

        $(this.$el).on('reInit beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.$eventsBus.$emit('slide-change', {nextSlide: nextSlide, currentSlide: currentSlide, numSlides: this.numSlides});
            if (this.numSlides > 0) {
                $('.gallery-paging').text(`${nextSlide + 1} of ${this.numSlides}`);
            }
        });

        // Slick's adaptiveHeight option doesn't work out of the box, at least not in the way that we use it. This will set the height dynamically...kind of. It's a hacky solution for a very specific design req from Drew.

        if (this.options.adaptiveHeight) {
            $(this.$el).on('afterChange', (event, slick, currentSlide, nextSlide)=> {
                const imageHeight = $(`[data-slick-index="${currentSlide}"] img`).height();
                $('.community-carousel .slick-list.draggable').attr('style', `height: ${imageHeight}px;`)
            });
        }
        if (this.shouldFadeIn) {
            $(this.$el).find('.slick-track').css('opacity', 0).delay(1000).animate({opacity: 1}, 1000);
        }
    },
    computed: {
        numSlides() {
            let count = 0;
            if (this.$slots.default) {
                this.$slots.default.forEach(val => {
                    if (val.context) {
                        count++;
                    }
                });
            }
            return count;
        },
        ...mapGetters({
            getData: 'modal/getData'
        }),
        modalImageIndex() {
            return this.getData.modalImageIndex;
        }
    },
    watch: {
        getData: function() {
            if (this.slick) {
                this.$nextTick(() => {
                    $(this.$el).slick('getSlick').refresh();
                });
            }
        }
    }
};
</script>
